import React from 'react';
import App, { AppInitialProps, AppContext } from 'next/app';
import TagManager from 'react-gtm-module';

import { reduxWrapper } from 'store';
import * as Sentry from '@sentry/node';

import isProd from 'utils/isProd';
import isStaging from 'utils/isStaging';
import getHost from 'utils/getHost';

import { initializeApplication } from 'state/actions/applicationActions';

import Layout from 'components/Layout';

import 'what-input';
import 'styles/App.scss';

import { GoogleTagManagerConfig } from 'constants/Global';

if (process.env.SENTRY_ENABLED) {
  if (isProd() || isStaging()) {
    let subdomain = getHost().split('.')[0];
    let env;
    if (subdomain === 'www') {
      env = 'production';
    } else {
      env = subdomain === 'staging' ? 'staging' : 'dev';
    }
    Sentry.init({
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN as string,
      environment: env as string,
    });
  }
}

class AppContainer extends App<AppInitialProps> {
  componentDidMount() {
    TagManager.initialize(GoogleTagManagerConfig);
  }

  public static getInitialProps = async ({ ctx }: AppContext) => {
    const { store } = ctx;

    return store.dispatch(initializeApplication() as any).then(() => {
      return {
        pageProps: {},
      };
    });
  };

  public render() {
    const { Component, pageProps } = this.props;
    // Workaround for https://github.com/vercel/next.js/issues/8592
    const err = (this.props as any).err;
    const modifiedPageProps = { ...pageProps, err };

    return (
      <Layout>
        <Component {...modifiedPageProps} />
      </Layout>
    );
  }
}

export default reduxWrapper.withRedux(AppContainer);
